import { graphql } from 'gatsby'
import { object } from 'prop-types'
import { documentToReactComponents } from '@contentful/rich-text-react-renderer'
import { ArrowRight } from 'components/svgs'
import InvestorForm from 'components/InvestorForm'
import { mergeFiles, getFileExtension } from 'utils/files'
import { Layout } from 'ui/Layout'
import {
  Wrapper,
  Head,
  Category,
  Title,
  Subtitle,
  Body,
  Image,
  ButtonWrapper,
  Button,
  htmlOptions,
} from './style'

const propTypes = {
  data: object,
}

const Content = ({ data }) => {
  const {
    category,
    title,
    subtitle,
    body,
    slug,
    image,
    imageToSocialMedia,
    uniqueFile,
    documents,
  } = data.contentfulContent

  const metatags = {
    slug: `/${category.slug}/${slug}`,
    title: `Creditas | ${title}`,
    description: subtitle?.internal?.content || title,
    imageToSocialMedia,
  }

  const buttonProps = {
    variant: 'actionLink',
    icon: ArrowRight,
  }

  const content = body?.[0]?.json || false
  const [{ files }] = mergeFiles([{ uniqueFile, documents }])

  return (
    <Layout metatags={metatags}>
      <Wrapper>
        <Head>
          {category && (
            <Category to={`/${category.slug}`}>{category.title}</Category>
          )}
          {title && <Title component="h1">{title}</Title>}
          {subtitle && (
            <Subtitle
              dangerouslySetInnerHTML={{
                __html: subtitle?.internal?.content,
              }}
            />
          )}
        </Head>

        {content && (
          <Body>
            {image && <Image {...image} alt={title} />}
            {documentToReactComponents(content, htmlOptions)}
          </Body>
        )}
      </Wrapper>

      {files?.length ? (
        <ul>
          {files.map(
            ({ file }) =>
              file?.url && (
                <ButtonWrapper key={file.url}>
                  <Button
                    label={`View file (${getFileExtension(file.url)})`}
                    variant="actionLink"
                    actionType="link"
                    as="a"
                    actionHref={`https:${file.url}`}
                    target="_blank"
                    rel="noreferrer"
                    {...buttonProps}
                  />
                </ButtonWrapper>
              ),
          )}
        </ul>
      ) : null}

      <InvestorForm />
    </Layout>
  )
}

export const pageQuery = graphql`
  query ContentfulBlogPostBySlug($slug: String!) {
    contentfulContent(slug: { eq: $slug }) {
      title
      slug
      subtitle {
        internal {
          content
        }
      }
      documents: files {
        id
        title
        file {
          url
        }
      }
      uniqueFile: file {
        id
        title
        file {
          url
        }
      }
      image {
        ...ContentfulImage
      }
      imageToSocialMedia {
        ...ContentfulImage
      }
      category {
        title
        slug
      }
      body: childrenContentfulContentContentRichTextNode {
        json
      }
    }
  }
`

Content.propTypes = propTypes

export default Content
